import { render, staticRenderFns } from "./CellRendererName.vue?vue&type=template&id=05f98360&scoped=true&"
import script from "./CellRendererName.vue?vue&type=script&lang=js&"
export * from "./CellRendererName.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererName.vue?vue&type=style&index=0&id=05f98360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f98360",
  null
  
)

export default component.exports